import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as types from "../constants/actionTypes";
import * as auth from "../tools/auth0.cred";
import * as api from "../tools/apiConfig";
import jQuery from "jquery";
import axios from "axios";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
} from "react-device-detect";
import index from "../components";
import constant from "../constants/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as url from "../tools/config";
import openSocket from "socket.io-client";
let environment = process.env.REACT_APP_NODE_ENV ? process.env.REACT_APP_NODE_ENV : 'development'
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
const google = window.google;
var countries = require("country-data").countries,
    currencies = require("country-data").currencies,
    regions = require("country-data").regions,
    languages = require("country-data").languages,
    callingCountries = require("country-data").callingCountries;
var toggle = true;


export function signUpUser(signupdata) {
    
    return function (dispatch, getState) {
        axios
            .post(api.SIGN_UP_USER, JSON.stringify(signupdata), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    if (signupdata.createdBy === 'Specialist')
                        toast.info('Email has been send to the user')
                    else
                        toast.info(response.data.message);
                    response.data.data.userData.success = true;

                    return dispatch({
                        type: types.SIGN_UP_USER,
                        userData: response.data.data.userData
                    });
                } else {
                    response.data.message = response.data.message.replace(
                        /\[\[(.*?)\]\]/g,
                        signupdata.email
                    );
                    toast.error(response.data.message);
                    response.data.data = {};
                    response.data.data.userData = {};
                    response.data.data.userData.success = false;
                    return dispatch({
                        type: types.SIGN_UP_USER,
                        userData: response.data.data.userData
                            ? response.data.data.userData
                            : {}
                    });
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };
}

export function signinUser(signindata, props) {
    var device = deviceDetect();

    signindata = { ...signindata, device, }
    
    return function (dispatch, getState) {

        axios
            .post(api.SIGN_IN_USER, JSON.stringify(signindata), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                
                if (response.data.code == 200) {
                    
                    socket.emit("adduser", { userId: response.data.data._id });
                    socket.on("notify_client", function (messageData) {
                        console.log("notify_client", messageData)

                        let url =
                            messageData.videoData.userType == "patient"
                                ? "/specialist/waiting-room-receiver/" +
                                messageData.videoData.videoId +
                                "/" +
                                messageData.videoData.appointmentId
                                : "/dashboard/waiting-room-receiver/" +
                                messageData.videoData.videoId +
                                "/" +
                                messageData.videoData.appointmentId;

                        let videoDataObj = messageData.videoData;
                        confirmAlert({
                            title: "Confirm",
                            message: messageData.videoData.userType == 'specialist' ?
                                "Incoming Video Call  Dr. " +
                                messageData.videoData.userName + " wishes to consult you." :
                                "Incoming Video Call from " +
                                messageData.videoData.userName + "",
                            buttons: [
                                {
                                    label: "Accept",
                                    onClick: () => {
                                        localStorage.setItem('videoDataObj', JSON.stringify(messageData.videoData))
                                        props.history.push(url);
                                    }
                                },
                                {
                                    label: "Decline",
                                    onClick: () => {
                                        socket.emit(
                                            "notrecieved",
                                            {
                                                videoData: videoDataObj,
                                                notificationType: "VIDEO_CALL_NOTRECIEVED"
                                            },
                                            function () {
                                                alert("here");
                                            }
                                        );
                                    }
                                }
                            ]
                        });
                    });

                    socket.on("notify_receive", function (messageData) {
                        
                        let title =
                            messageData.videoData.userType == "patient"
                                ? "specialist"
                                : "patient";
                        let url =
                            messageData.videoData.userType == "patient"
                                ? "/specialist/video-call-connect/" +
                                messageData.videoData.videoId
                                : "/dashboard/video-call-connect/" + messageData.videoData.videoId;
                        // let fullUrl = constant.VIDEO_CALL_URL + url;
                        // 
                        props.history.push(url);	// clinetlive
                        //  props.history.push("https://test.medfixhealth.com" + url);	// clineTestlive
                        // window.open('http://52.34.207.5:5127' + url, title, 'toolbar=0,status=0,width=548,height=325'); //staging
                        //
                        // props.history.push("http://localhost:3000" + url);
                        //  window.open('http://localhost:3000' + url, title, 'toolbar=0,status=0,width=548,height=325', "_blank");//local
                        //sagar local
                        // props.history.push("http://172.10.28.60:3000" + url);
                        //ridhi local
                        // props.history.push("http://172.10.28.60:3000" + url);
                        // window.open('http://172.10.221.185:3000' + url, title, 'toolbar=0,status=0,width=548,height=325', "_blank");//local sagar
                        // window.open('http://localhost:3000' + url);//local
                        // props.history.push(url)
                    });
                    //done image
                    socket.on("notify_disconnet_call", function (messageData) {
                        console.log("notify_disconnet_call", messageData)
                        // alert('called  notify_disconnet_call');
                        // window.close();

                        let routePath =
                            messageData.userType == "patient"
                                ? "/specialist/my-appointment" : "/dashboard/my-appointment";

                        let message =
                            messageData.userType == "patient"
                                ? "Call disconneted from " + messageData.userType
                                : "Call disconneted from " + messageData.userType;

                        props.history.push(routePath);
                        toast.info(message);
                    });

                    // 	let routePath =	(messageData.userType == "patient")? "/specialist/my-appointment" : '/specialist/appointment-consultation/';
                    // 			// ? "/specialist/my-appointment" : "/verify-user";
                    // 	let message =
                    // 		messageData.userType == "patient"
                    // 			? "Call disconneted from " + messageData.userType
                    // 			: "Call disconneted from " + messageData.userType;

                    // 	props.history.push(routePath);
                    // 	toast.info(message);

                    // });



                    socket.on("notify_notrecieved_call", function (messageData) {
                        this.setState({
                            newId: localStorage.getItem('appointmentId')
                        })
                        let appointmentObj = {
                            appointmentId: this.state.newId
                        }
                        this.props.actions.getAppointmentDetails(appointmentObj);
                        let routePath =
                            messageData.videoData.userType == "patient"
                                ? "/dashboard/my-appointment"
                                : '/specialist/appointment-consultation/' + this.state.newId;
                        let message =
                            messageData.videoData.userType == "patient"
                                ? "Specialist may busy with another call. Please try after some time"
                                : "Patient may busy with another call. Please try after some time";
                        props.history.push(routePath);
                        toast.info(message);
                    });
                    if (response.data.data.type == "patient") {


                        // if (
                        // 	response.data.data.userName == undefined &&
                        // 	response.data.data.gender == undefined &&
                        // 	response.data.data.dateOfBirth == null
                        // ) {

                        // 	props.history.push("/my-setting");
                        // } else {
                        // 	localStorage.setItem("feedbackRemind", true);
                        // 	if (
                        // 		localStorage.getItem("availabilityId") &&
                        // 		(localStorage.getItem("availabilityId") != null &&
                        // 			localStorage.getItem("availabilityId") != "") &&
                        // 		localStorage.getItem("fromMarketPage") &&
                        // 		(localStorage.getItem("fromMarketPage") != null &&
                        // 			localStorage.getItem("fromMarketPage") != false)
                        // 	) {
                        // 		props.history.push("/book-appointment-calendar");
                        // 	} else {
                        // 		props.history.push("/my-appointment");
                        // 	}
                        // }
                        localStorage.setItem("fee1", "");
                        localStorage.setItem("fee2", "");
                        localStorage.setItem("fee3", "");

                        localStorage.setItem("specializationId", "");
                        localStorage.setItem("specializationName", "");

                        localStorage.setItem("rateValue", "");
                        localStorage.setItem("mileDistance", 0);
                        localStorage.setItem("zipcode", "");
                        localStorage.setItem("gender", "");

                        // toast.info(response.data.message);


                        navigator.geolocation.getCurrentPosition(
                            function (position) {
                                // success cb
                                var lat = position.coords.latitude;
                                var lng = position.coords.longitude;
                                
                                localStorage.setItem("lat", lat);
                                localStorage.setItem("lng", lng);
                                axios
                                    .get(
                                        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                                        lat +
                                        "," +
                                        lng +
                                        "&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk"
                                    )
                                    .then(function (response) {
                                        if (response) {
                                            for (var i = 0; i < response.data.results.length; i++) {
                                                if (response.data.results[i].types[0] == "country") {
                                                    var countryshort =
                                                        response.data.results[i].address_components[0]
                                                            .short_name;
                                                    
                                                    localStorage.setItem("country_short", countryshort);
                                                    localStorage.setItem(
                                                        "currency",
                                                        countries[countryshort].currencies[0]
                                                    );
                                                    localStorage.setItem(
                                                        "calling_code",
                                                        countries[countryshort].countryCallingCodes[0]
                                                    );
                                                }
                                            }
                                        } else {
                                        }
                                    })
                                    .catch(function (error) {
                                        toast.error(error);
                                    });
                            },
                            function () {
                                // fail cb
                                localStorage.setItem("lat", 0);
                                localStorage.setItem("lng", 0);
                            }
                        );

                        dispatch({
                            type: types.SIGN_IN_USER,
                            signin: response.data.data
                        });
                    } else if (response.data.data.type == "specialist") {

                        // if (
                        // 	response.data.data.userName == undefined ||
                        // 	response.data.data.gender == undefined ||

                        // 	response.data.data.availabilityCount == 0 ||

                        // 	response.data.data.isVerified !="2")
                        //  {
                        // 	
                        // 	props.history.push("/specialist/my-profile");
                        // } else {
                        // 	props.history.push("/specialist/my-appointment");
                        // }
                        localStorage.setItem("noShowRemind", true);
                        // toast.info(response.data.message);
                        dispatch({
                            type: types.SIGN_IN_USER,
                            signin: response.data.data
                        });
                    }
                } else {
                    toast.error(response.data.message);
                    dispatch({
                        type: types.SIGN_IN_USER,
                        signin: 'falied'
                    });
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };
}

export function forgotPassword(data) {
    return function (dispatch, getState) {
        axios
            .post(api.FORGOT_PASSWORD, JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    toast.info(response.data.message);
                    setTimeout(function () {
                        response.data.data.success = true;
                        return dispatch({
                            type: types.FORGOT_PASSWORD,
                            data: response.data.data
                        });
                    }, 3000);
                } else {
                    toast.error(response.data.message);
                    response.data.data = {};
                    response.data.data.success = false;
                    return dispatch({
                        type: types.FORGOT_PASSWORD,
                        data: response.data.data
                    });
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };
}

export function resetPassword(data) {
    return function (dispatch, getState) {
        axios
            .post(api.RESET_PASSWORD, JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    toast.info(response.data.message);
                    response.data.data.success = true;
                    return dispatch({
                        type: types.RESET_PASSWORD,
                        data: response.data.data
                    });
                } else {
                    toast.error(response.data.message);
                    response.data.data = {};
                    response.data.data.success = false;
                    return dispatch({
                        type: types.RESET_PASSWORD,
                        data: response.data.data
                    });
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };
}

export function activateAccount(data) {
    return function (dispatch, getState) {
        axios
            .post(api.ACTIVATE_ACCOUNT, JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    toast.info(response.data.message);
                    response.data.data.success = true;
                    return dispatch({
                        type: types.ACTIVATE_ACCOUNT,
                        data: response.data.data
                    });
                } else {
                    toast.error(response.data.message);
                    response.data.data.success = false;
                    return dispatch({
                        type: types.ACTIVATE_ACCOUNT,
                        data: response.data.data
                    });
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };
}

export function changeEmail(data) {
    return function (dispatch, getState) {
        axios
            .post(api.CHANGE_EMAIL, JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    toast.info(response.data.message);
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
    };
}

export function unLockAccount(data) {
    return function (dispatch, getState) {
        axios
            .post(api.UNLOCK_ACCOUNT, JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info(response.data.message);
                    response.data.data.success = true;
                    return dispatch({
                        type: types.UNLOCK_ACCOUNT,
                        data: response.data.data
                    });
                } else {
                    // toast.error(response.data.message);
                    response.data.data.success = false;
                    return dispatch({
                        type: types.UNLOCK_ACCOUNT,
                        data: response.data.data
                    });
                }
            })
            .catch(function (error) {
                // toast.error(error);
            });
    };
}
export function unSubscribe(data) {
    return function (dispatch, getState) {
        axios
            .post(api.UNSUBSCRIBE_EMAILS, JSON.stringify(data), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                if (response.data.code == 200) {
                    // toast.info(response.data.message);
                    response.data.data.success = true;
                    return dispatch({
                        type: types.UNSUBSCRIBE_EMAILS,
                        data: response.data.data
                    });
                } else {
                    // toast.error(response.data.message);
                    response.data.data.success = false;
                    return dispatch({
                        type: types.UNSUBSCRIBE_EMAILS,
                        data: response.data.data
                    });
                }
            })
            .catch(function (error) {
                // toast.error(error);
            });
    };
}
export function otpVerification(data) {
    return function (dispatch, getState) {
        axios
            .post(api.OTP_VERIFICATION, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                // debugger
                // toast.info("Logged in Successfully");
                if (response.data.code == 200) {
                    toast.info("Logged in Successfully");

                    // toast.info(response.data.message);
                    // response.data.data.success = true;
                    let res = {
                        success: true,
                        message: response.data.message
                    }
                    setTimeout(function () {
                        
                        return dispatch({
                            type: types.OTP_VERIFICATION,
                            data: res
                        });
                    }, 1000);


                } else {
                    toast.error(response.data.message);
                    // response.data.data.success = false;
                    let res = {
                        success: false,
                        message: response.data.message
                    }
                    setTimeout(function () {
                        return dispatch({
                            type: types.OTP_VERIFICATION,
                            data: res
                        });
                    }, 1000);
                }
            })
            .catch(function (error) {
                // toast.error(error);
            });
    };
};

// resend otp
export function resendOtpVerification(signindata) {
    var device = deviceDetect();

    signindata = { ...signindata, device, }
    
    return function (dispatch, getState) {

        axios
            .post(api.RESEND_OTP, JSON.stringify(signindata), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(function (response) {
                
                if (response.data.code == 200) {
                    toast.info("OTP has been re-sent");
                    dispatch({
                        type: types.RESEND_OTP,
                        resendOTP: true/* response.data.data */
                    });
                }else {
                    toast.warn("Failed to send OTP");
                    dispatch({
                        type: types.RESEND_OTP,
                        resendOTP: false/* response.data.data */
                    });
                }
            })
            .catch(function (error) {
                toast.error(error);
            });
        }
}
